<app-common-table
  #cnTable
  [title]="title"
  [crumbsMenu]="crumbs"
  [actions]="actions"
  [burgerActions]="burgerActions"
  [columns]="columns"
  (onLoadItemsEvent)="onLoadItemsEvent($event)"
  (onActionClickEmit)="onActionClickEmit($event)"
  [showAddButton]="false"
  (onAddClick)="onAddClick()"
  [isLoading]="isLoading"
  [showStatusBadgeFilter]="this.type != 'BrandRegistrationCertificates'"
  [badgeFilterItems]="badgeFilterItems"
  (onBadgeFilterEmit)="onBadgeFilterEmit($event)">
</app-common-table>
